import axios from "axios";

export default axios.create({
  baseURL: "https://net-12.com/api/v1/",
});
